import { EditableCard } from "../../../components/editableCard.component";
import { ApiSchemaCompany } from "../../../models/api";
import { AppRouteUi } from "../../../config/appRoute";
import { useParams } from "react-router";
import { FileList } from "../../../components/fileList.component";
import companyDocument from "../../../assets/img/Certificate.svg";

type Props = {
  data: ApiSchemaCompany | undefined;
  isValidating: boolean;
};

export const DocumentsListCard = (props: Props) => {
  const { companyId } = useParams<{ companyId: string }>();
  return (
    <EditableCard
      title="Documents"
      showLoader
      isValidating={props.isValidating}
      link={`${AppRouteUi.Company.Root()}/update/${companyId}`}
      className=""
    >
      <>
        {props.data?.documents.length ? (
          <FileList
            files={props.data.documents}
            icon={companyDocument}
            underScoreCount={4}
          />
        ) : (
          <p className="text-center">No Documents Available.</p>
        )}
      </>
    </EditableCard>
  );
};
